import React, { useState } from 'react';
import {UserData} from "../../components/search/admin-dashboard-tables/interfaces";

const useCurrentUser = () => {
  const [currentUser] = useState<UserData>(
    window.user
      ? { id: window.user.id, public_key: window.user.public_key }
      : { id: 0, public_key: '' },
  );

  return {
    currentUser,
  };
};

export default useCurrentUser;
